import { render, staticRenderFns } from "./BulletRating.vue?vue&type=template&id=420a736a&scoped=true&"
import script from "./BulletRating.vue?vue&type=script&lang=ts&"
export * from "./BulletRating.vue?vue&type=script&lang=ts&"
import style0 from "./BulletRating.vue?vue&type=style&index=0&id=420a736a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a736a",
  null
  
)

export default component.exports